import { render, staticRenderFns } from "./KommanderDetails.vue?vue&type=template&id=246c027d&scoped=true"
import script from "./KommanderDetails.vue?vue&type=script&lang=js"
export * from "./KommanderDetails.vue?vue&type=script&lang=js"
import style0 from "./KommanderDetails.vue?vue&type=style&index=0&id=246c027d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246c027d",
  null
  
)

export default component.exports